import { Clock, ShieldAlert, CheckCircle2, XCircle } from "lucide-react";

// Business rules mirrored from backend.
export const RETURN_WINDOW_DAYS = 7;
export const VENDOR_RESPONSE_HOURS = 48;
export const VENDOR_FULFIL_DAYS = 5;

export const STATUS_META = {
  pending_vendor: { label: "Awaiting exhibitor response", tone: "amber" },
  accepted: { label: "Accepted — awaiting fulfilment", tone: "blue" },
  rejected: { label: "Rejected by exhibitor", tone: "red" },
  completed: { label: "Completed", tone: "green" },
  escalated_vendor_delayed: { label: "Escalated · exhibitor missed 48h", tone: "red" },
  escalated_fulfilment_delayed: { label: "Escalated · fulfilment overdue", tone: "red" },
};

const TONE = {
  amber: "bg-amber-50 border-amber-200 text-amber-800",
  blue: "bg-blue-50 border-blue-200 text-blue-800",
  red: "bg-red-50 border-red-200 text-red-700",
  green: "bg-green-50 border-green-200 text-green-700",
  gray: "bg-gray-50 border-gray-200 text-gray-700",
};

export function StatusPill({ status, testid }) {
  const m = STATUS_META[status] || { label: status, tone: "gray" };
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONE[m.tone]}`}>
      {m.tone === "green" && <CheckCircle2 className="h-3 w-3" />}
      {m.tone === "red" && <ShieldAlert className="h-3 w-3" />}
      {m.tone === "amber" && <Clock className="h-3 w-3" />}
      {m.tone === "blue" && <Clock className="h-3 w-3" />}
      {m.label}
    </span>
  );
}

// Returns { text, tone } for a countdown against an ISO deadline.
export function formatCountdown(deadlineIso, now = new Date()) {
  if (!deadlineIso) return null;
  const d = new Date(deadlineIso);
  const ms = d.getTime() - now.getTime();
  const overdue = ms < 0;
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3600000);
  const days = Math.floor(h / 24);
  const remH = h % 24;
  const parts = days > 0 ? `${days}d ${remH}h` : `${h}h ${Math.floor((abs % 3600000) / 60000)}m`;
  return {
    text: overdue ? `Overdue by ${parts}` : `${parts} left`,
    tone: overdue ? "red" : (h < 12 ? "amber" : "blue"),
  };
}

export function CountdownChip({ deadlineIso, testid, prefix }) {
  const c = formatCountdown(deadlineIso);
  if (!c) return null;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${TONE[c.tone]}`}>
      <Clock className="h-3 w-3" />{prefix ? `${prefix} · ` : ""}{c.text}
    </span>
  );
}

export function fmtDate(iso) {
  try { return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}

export { XCircle };
